const VatStatementsContainer = () =>
  import('../screens/VAT/VatStatements/VatStatementsContainer.vue');
const VatInvoiceContainer = () => import('../screens/VAT/VatInvoice/VatInvoiceContainer.vue');

export default [
  {
    component: VatStatementsContainer,
    meta: {
      activeSidebarItemId: 'vat-statements',
      authority: 'vat_statements:view',
      pageTitle: 'Generate Vat Statement',
    },
    name: 'vat-statements',
    path: '/vat-statements',
  },
  {
    component: VatInvoiceContainer,
    meta: {
      activeSidebarItemId: 'vat-invoice',
      authority: 'vat_invoices:download',
      pageTitle: 'Retrieve VAT Invoice',
    },
    name: 'vat-invoice',
    path: '/vat-invoice',
  },
];
